"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var disabled = _a.disabled, _b = _a.cursor, cursor = _b === void 0 ? 'auto' : _b;
    return "\n  opacity: " + (disabled ? 0.4 : 1) + ";\n  pointer-events: " + (disabled ? 'none' : 'auto') + ";\n  cursor: " + (disabled ? 'default' : cursor) + ";\n";
});
